import { useUiStore } from '@common/stores';
import type { SchemeType } from '@common/types';
import type { GlobalConfigType, InitGlobalConfigType } from '@shared/types';
import { defineStore } from 'pinia';

const enumToSchemeType = (enumValue: number): SchemeType => {
  switch (enumValue) {
    case 1: return 'light';
    case 2: return 'dark';
    default: 'system';
  }
  return 'system';
};

export const useGlobalConfigStore = defineStore('globalConfigStore', {
  state: () => {
    return {
      allowRegistration: false,
      allowForgotPassword: false,
      countries: ['CO'],
      keyboardEnabled: true,
      requestToken: '',
      headerName: '',
      showPasswordEnabled: true,
      isRaw: false,
      passwordPolicies: {
        minLength: 8,
        maxLength: 60,
        minLowerCase: 1,
        minUpperCase: 1,
        minNumbers: 1,
        minSpecialCharacters: 1,
        allowedSpecialCharacters: '!#$@*.',
      },
    } as GlobalConfigType;
  },
  actions: {
    async initializeAsync() {
      const globalConfig: InitGlobalConfigType = (window as any).$config ?? {};
      await this.initializeFromConfigAsync(globalConfig);
    },

    async initializeFromConfigAsync(config: InitGlobalConfigType) {
      const uiStore = useUiStore();

      this.headerName = config.hn;
      this.requestToken = config.rtkn;
      this.isRaw = window.location.search.indexOf('raw=true') >= 0;

      const login = config.login;
      if (login) {
        this.allowRegistration = login.ar;
      }

      const tenant = config.tn;
      if (tenant) {
        uiStore.setRealm({
          id: tenant.id,
          name: tenant.dn,
          logoDark: tenant.ld,
          logoLight: tenant.ll,
        });
      }

      const theme = config.th;
      if (theme) {
        uiStore.setTheme({
          color: theme.co,
          scheme: this.isRaw ? 'light' : enumToSchemeType(theme.sch),
        });
      }

      const passwordPolicies = config.pp;
      if (passwordPolicies) {
        this.passwordPolicies.minLength = passwordPolicies.mil;
        this.passwordPolicies.maxLength = passwordPolicies.mal;
        this.passwordPolicies.minSpecialCharacters = passwordPolicies.msc;
        this.passwordPolicies.minNumbers = passwordPolicies.mnm;
        this.passwordPolicies.minLowerCase = passwordPolicies.mlc;
        this.passwordPolicies.minUpperCase = passwordPolicies.muc;
        this.passwordPolicies.allowedSpecialCharacters = passwordPolicies.asc;
      }
    },
  },
});